import React, { ReactNode } from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: "50px 5% 0px 5%",
    width: "90%"
  },
}));

export default function Content({ children }: { children: ReactNode }) {
  const classes = useStyles();

  return <div className={classes.container}>{children}</div>;
}
